import useRankingTable from '../../../hooks/useRankingTable';
import { Table } from '../../Table';
import { Errors } from '../style';
import { StyledTables } from '../style';
import { TableComponentProps } from '../types';

const columnLables = {
  ranking: {
    name: 'Ranking (AIFM principal instruments)'
  },
  sub_asset_type: {
    name: 'Sub-asset type code of the principal instrument'
  },
  aggregated_value_amount: {
    name: 'Aggregated value of the principal instrument'
  }
};

export function PrincipalInstruments({
  onChangeFund,
  funds,
  currentDataKey,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const {
    tables,
    columns: columns,
    onChange: onChange
  } = useRankingTable({
    data: funds[currentDataKey]?.fund_data?.AIFM_PRINCIPAL_INSTRUMENT,
    onChangeFund,
    schema: schema.AIFM_PRINCIPAL_INSTRUMENT,
    isStaticTemplate,
    requiredFields:
      funds[currentDataKey]?.required_tables?.AIFM_PRINCIPAL_INSTRUMENT?.field_names || [],
    columnLables,
    isMultiFunds,
    funds,
    tableName: 'AIFM_PRINCIPAL_INSTRUMENT',
    order: 30,
    hasOrderNumber: false
  });

  const isRequiredTable =
    funds[currentDataKey]?.required_tables?.AIFM_PRINCIPAL_INSTRUMENT?.field_names?.length === 0;

  const errors = funds[currentDataKey]?.fund_data?.AIFM_PRINCIPAL_INSTRUMENT?.find(
    item => item?.errors?.general
  )?.errors?.general;

  return (
    <>
      <Errors id="reporttables-principal-instruments-errors">
        {isRequiredTable && (
          <li id="reporttables-principal-instruments-required-error">
            This section must be completed
          </li>
        )}
        {errors?.map(item => (
          <li key={item.msg} id={`reporttables-principal-instruments-error-${item.msg}`}>
            {item.msg}
          </li>
        ))}
      </Errors>

      <StyledTables id="reporttables-principal-instruments-group">
        {tables.map((rows, index) => (
          <Table
            key={index + 'AIFM_FIVE_PRINCIPAL_MARKET'}
            id={`reporttables-principal-instruments-table-${index + 1}`}
            handleChanges={onChange}
            columns={columns}
            rows={rows}
            stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 2 : null}
          />
        ))}
      </StyledTables>
    </>
  );
}
